import React, { Component } from 'react'
import { withTranslation } from 'react-i18next'
import axios from 'axios'

import Konsesjonsforhold from './Konsesjonsforhold.jsx'
import KonsesjonsforholdIcon from '../../../images/Konsesjonsforhold.png'
import CollapseIcon from '../../../images/expand copy 3.png'
import ExpandIcon from '../../../images/collapse copy 3.png'

class KonsesjonsforholdList extends Component {
    state = {
        konsesjonsforhold: [],
        isLoading: false,
        isOpened: false,
        continuationToken: null        
    }

    getKonsesjonsforhold = () => {
        this.setState({isLoading: true})
        axios.get(`${this.props.settings.baseUrl}api/matrikkelenhet/${this.props.matrikkelenhetId}/konsesjonsforhold`, {
            params: {
                token: this.props.token,
                size: 50,
                continuationToken: this.state.continuationToken                
            }
        })
        .then(({data}) => {
            this.setState({
                konsesjonsforhold: [...this.state.konsesjonsforhold, ...data.konsesjonsforhold],
                isLoading: false,
                continuationToken: data.nextContinuationToken                
            })
        })
      }


      toggleKonsesjonsforhold = () => {
        if (this.props.antall == 0) return

        if (this.state.konsesjonsforhold.length == 0) {
            this.getKonsesjonsforhold()
        }

        this.setState({isOpened: !this.state.isOpened})
    }

    render() {
        const { t } = this.props
        var antallKonsesjonsforhold = this.state.continuationToken ? `${this.state.konsesjonsforhold.length}/${this.props.antall}` : this.props.antall        
        return (
            <li>
                <div className="section-header" onClick={this.toggleKonsesjonsforhold}>
                    { !this.state.isLoading &&
                        <div className="icon-image"><img src={KonsesjonsforholdIcon} /></div>
                    }
                    {
                        this.state.isLoading &&
                        <span className="icon"><i className="fa fa-fw fa-spinner fa-spin"></i></span>
                    }
                    <span className="title">{t('konsesjonsforhold')} ({antallKonsesjonsforhold})</span>
                    <div className="icon-image right"><img className="collapse" src={this.state.isOpened ? CollapseIcon : ExpandIcon} /></div>
                </div>
                <div className={this.state.isOpened && this.state.konsesjonsforhold.length > 0 ? "" : "collapsed"}>
                    <ul>
                        { this.state.konsesjonsforhold.map((k, index) => {return (<Konsesjonsforhold key={k.konsesjonsforholdId} konsesjonsforhold={k} antall={this.props.antall} isLast={index==this.state.konsesjonsforhold.length-1} token={this.props.token} settings={this.props.settings} />)}) }
                        { this.state.continuationToken &&
                        <li key="HentFlere">
                            <div className="section-header subsection button" onClick={this.getKonsesjonsforhold}>
                                <span>{t('hent.konsesjonsforhold')}</span>
                            </div>
                        </li>
                        }
                    </ul>
                </div>
            </li>
        )
    }
}

export default withTranslation('common')(KonsesjonsforholdList)